export default __webpack_public_path__ + "static/media/SJA1440.34I-42058_-25203_0.c0d3104b.jpg";